<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="mb-2 d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">{{ $t(title) }}</h4>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 d-none d-lg-table">
        <div v-if="isLoadingData" class="mt-2">
          <b-skeleton-table :rows="6" :columns="3"></b-skeleton-table>
        </div>
        <table class="table table-hover mt-2" v-else-if="documents.length > 0">
          <thead class="thead-light">
            <tr>
              <th>{{ $t("pages.documentType.designation") }}</th>
              <th>{{ $t("pages.documentType.status") }}</th>
              <th>{{ $t("pages.documentType.process") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(document, index) in documents" :key="index">
              <td>
                <a href="" @click.prevent="preview(document, $event)">
                  {{ document.name }}
                </a>
              </td>
              <td>
                <span
                  v-bind:class="{
                    'p-1 badge badge-success':
                      document.state_type === 'Approved',
                    'p-1 badge badge-warning':
                      document.state_type === 'Waiting',
                    'p-1 badge badge-danger':
                      document.state_type === 'Rejected',
                  }"
                >
                  {{ getStateName(document.state_type) }}
                  {{ document.state_type == "Waiting" ? document.state : "" }}
                </span>
              </td>
              <td>{{ document.process }}</td>
            </tr>
          </tbody>
        </table>
        <div class="text-center empty-state-container" v-else>
          <div class="row">
            <div class="col-md-3 mx-auto">
              <lottie-animation
                ref="anim"
                :animationData="require('@/assets/json/empty-state.json')"
                :loop="true"
              />
            </div>
          </div>
          <h4 class="text-center">{{ $t("menuitems.tasks.empty.title") }}</h4>
          <p class="mt-2">{{ $t("menuitems.tasks.empty.text") }}</p>
        </div>
      </div>
    </div>
    <div class="row mb-4" v-if="documents.length > 0">
      <div class="col-md-12">
        <div class="text-center">
          <b-pagination
            v-model="currentPage"
            pills
            :per-page="perPage"
            :total-rows="totalItems"
            align="center"
            aria-controls="tontine-table"
            @change="onChangePage"
          ></b-pagination>
        </div>
      </div>
    </div>
    <modal @changed="getTasks()" v-if="showModal" />
  </Layout>
</template>
  
<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import workflowApi from "../../../api/workflowApi";
import LottieAnimation from "lottie-web-vue";
import { mapActions, mapState } from "vuex";
import managerHelper from "../../../components/manager/mixins/manager";

export default {
  page: {
    title: "Workflows",
    meta: [{ name: "description", content: appConfig.description }],
  },
  mixins: [managerHelper],
  components: {
    Layout,
    LottieAnimation,
  },
  data() {
    return {
      documents: [],
      document: null,
      isProssDocumentDialogOpen: false,
      title: "menuitems.tasks.waiting.title",
      isLoadingData: false,
      labels: {
        first: "<<",
        last: ">>",
        next: ">",
        previous: "<",
      },
      pageSize: 2,
      currentPage: 1,
      perPage: 2,
      totalItems: 15,

    };
  },
  computed: {
    ...mapState({
      showModal: (state) => state.modal.showModal,
    }),
    count() {
      return this.documents.length;
    },
  },
  methods: {
    ...mapActions(["getNotifById", "getDocumentById", "getDocumentPath"]),
    preview(document, event) {
      this.getDocumentById(document.id).then((response) => {
        this.document = response.data;
        this.document.extension = document.extension;
        this.$store.commit(`left/setDirectoryContent`, {
          directories: [],
          files: [this.document],
        });
        this.selectItem("files", this.document.path, event);
        this.selectAction(this.document.path, document.extension);
      });
    },
    getStateName(state) {
      switch (state) {
        case "Waiting":
          return this.$t("pages.workflow.details.waiting");
        case "Approved":
          return this.$t("pages.workflow.details.approved");
        case "Rejected":
          return this.$t("pages.workflow.details.rejected");
        default:
          return this.$t("pages.workflow.details.cancelled");
      }
    },
    getTasks() {
      this.isLoadingData = true;
      workflowApi
        .getUserWaitingTasks(this.currentPage)
        .then((response) => {
          console.log( response.data);
          this.documents = response.data.data;
          this.currentPage = response.data.current_page;
          this.perPage = response.data.per_page;
          this.totalItems = response.data.total;
          this.isLoadingData = false;
        })
        .catch(() => {
          this.isLoadingData = false;
        });
    },
    onChangePage(pageNumber) {
      this.currentPage = pageNumber;
      this.isLoadingData = true;
      workflowApi
        .getUserWaitingTasks(this.currentPage)
        .then((response) => {
          this.documents = response.data.data;
          this.currentPage = response.data.current_page;
          this.perPage = response.data.per_page;
          this.totalItems = response.data.total;
          this.isLoadingData = false;
        })
        .catch(() => {
          this.isLoadingData = false;
        });
    },
  },
  created() {
    this.getTasks();
  },
};
</script>
  
  
  